import _ from 'lodash';
import React, { useEffect, useRef } from 'react';

import ChartJs from 'chart.js';
import 'chartjs-plugin-annotation';
import 'chartjs-plugin-zoom';
import { moneyFormatFromCents } from "../../utilities/moneyFormat.js";

export default function Chart(props) {
	const { type, data, onLegendClick, options, highlightIndex, ...remainingProps } = props;
	const canvasRef = useRef(null);
	const chart = useRef(null);

	useEffect(() => {
		if(highlightIndex !== null) {
			openToolTip(highlightIndex);
		}
		else {
			closeToolTip();
		}
	}, [highlightIndex]);

	useEffect(() => {
		console.log('chart mount!');
	}, []);

	useEffect(() => {
		console.log('chart updated!');
		updateChart();
	}, [type, data, options]);

	function openToolTip(index) {
		if(!chart.current) {
			return;
		}
		let mouseMoveEvent, meta, point, rectangle, value;
		meta = chart.current.getDatasetMeta(0);
		rectangle = chart.current.canvas.getBoundingClientRect();
		point = meta.data[index].getCenterPoint();

		mouseMoveEvent = new MouseEvent('mousemove', {
			clientX: rectangle.left + point.x,
			clientY: rectangle.top + point.y
		});

		chart.current.canvas.dispatchEvent(mouseMoveEvent);
	}

	function closeToolTip() {
		if(!chart.current) {
			return;
		}
		const mouseOutEvent = new MouseEvent('mouseout');
		return chart.current.canvas.dispatchEvent(mouseOutEvent);
	}

	function updateChart() {
		const { type, data, onLegendClick } = props;
		let { options } = props;
		if(!options) {
			options = {};
		}
		if(!options.legend) {
			options.legend = {};
		}

		const chartData = {
			type,
			data: _.cloneDeep(data),
			options: _.cloneDeep(options),
		};
		// DO ALL CHANGES TO THE OBJECT  BELOW HERE

		if(!chartData.options.legend && !chartData.options.legend.onClick) {
			chartData.options.legend.onClick = onLegendClick;
		}

		if(chart.current) {
			chart.current.data = chartData.data;
			chart.current.options = chartData.options;
			console.log('the options', chart.current.options);
			chart.current.update();
		}
		else {
			console.log('the data', chartData);
			chart.current = new ChartJs(canvasRef.current, chartData);
		}
	}


	return (
		<canvas
			width='800'
			height='500'
			{...remainingProps}
			ref={canvasRef}
		/>
	);

}
Chart.defaultProps = {
	highlightIndex: null
};

Chart.yAxesMoneyFormat = (value, index, values) => {
	return moneyFormatFromCents(value);
};
